import React, { useState } from "react";
import ChannelAddForm from "../../../../components/ChannelAddForm/ChannelAddForm";

import { addEmailChannel } from "../../../../../../services/api/channels/add/email";
import { verifyEmailChannel } from "../../../../../../services/api/channels/verify/email";
import { ApiError } from "../../../../../../shared/utils/errors/ApiError";

import {
  StepChannelName,
  StepEmailInput,
  StepEmailVerification,
  StepResult,
} from "./steps";

export default function CreateIntegrationSesPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [channelName, setChannelName] = useState("");
  const [nameError, setNameError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [verificationError, setVerificationError] = useState("");

  const validateName = () => {
    if (!channelName.trim()) {
      setNameError("Digite um nome para o canal.");
      return;
    }
    setNameError("");
    setCurrentStep(2);
  };

  const handleAdd = async () => {
    if (!email.trim()) {
      setEmailError("Digite um e-mail.");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError("Digite um e-mail válido.");
      return;
    }

    try {
      setLoading(true);

      const result = await addEmailChannel({
        name: channelName,
        from: email,
      });

      if (result.message === "Verifique seu e-mail") {
        setCurrentStep(3);
      } else {
        setCurrentStep(4);
      }
    } catch (err) {
      if (err instanceof ApiError) {
        setEmailError(err.message);
        return;
      }
      setSuccess(false);
      setCurrentStep(4);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async () => {
    try {
      setLoading(true);
      setVerificationError("");

      const result = await verifyEmailChannel({ email });

      if (result.message === "Email verified successfully") {
        setSuccess(true);
        setCurrentStep(4);
      } else {
        setVerificationError(
          "A verificação ainda não foi concluída. Clique no link enviado por e-mail."
        );
      }
    } finally {
      setLoading(false);
    }
  }; 

  const steps = [
    {
      title: "Vamos começar?",
      description: <span>Escolha um nome interno para este canal.</span>,
      content: (
        <StepChannelName
          value={channelName}
          error={nameError}
          onChange={setChannelName}
        />
      ),
    },
    {
      title: "Qual e-mail deseja conectar?",
      description: <span>Insira o e-mail que será utilizado.</span>,
      content: (
        <StepEmailInput value={email} error={emailError} onChange={setEmail} />
      ),
    },
    {
      title: "Confirme seu e-mail",
      description: <span>Clique no link enviado para seu e-mail.</span>,
      content: (
        <StepEmailVerification error={verificationError} email={email} />
      ),
    },
    {
      title: success ? "E-mail conectado com sucesso!" : "Ops! Algo deu errado",
      description: <StepResult success={success} />,
    },
  ];

  return (
    <ChannelAddForm
      steps={steps}
      success={success}
      loading={loading}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      onSubmit={[validateName, handleAdd, handleVerify]}
      disableBack={loading}
    />
  );
}
